import { Heading, List } from '@react/chakra';

import type { JSX } from 'react';

import { buildHeadingId } from './utils';

import type { IContentTreeProps } from './interface';

interface IItemProps {
  data: IContentTreeProps;
}

export function Item({ data, ...rest }: IItemProps): JSX.Element {
  const { text, level } = data;
  const id = buildHeadingId(data);

  const handleClick = () => {
    document.querySelector(`.markdown-content [id="${id}"]`)?.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    });
  };

  return (
    <List.Item cursor='pointer' listStyleType='none' {...rest}>
      <Heading
        p={3}
        id={id}
        size='lg'
        px={(level - 1) * 4}
        onClick={handleClick}
        _hover={{
          color: 'gray.200',
        }}
        _statusActive={{
          color: 'black',
          bgColor: 'gray.200',
          _hover: {
            color: 'black',
          },
        }}
      >
        {text}
      </Heading>
    </List.Item>
  );
}
